var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Reviewed_Icon",
    "data-name": "Reviewed Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.636,
    height: 15.584,
    viewBox: "0 0 13.636 15.584",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_166115",
    "data-name": "Path 166115",
    d: "M5.172,3.375H4.2A1.948,1.948,0,0,0,2.25,5.323V15.55A1.948,1.948,0,0,0,4.2,17.5h9.74a1.948,1.948,0,0,0,1.948-1.948V5.323a1.948,1.948,0,0,0-1.948-1.948h-.974v.974h.974a.974.974,0,0,1,.974.974V15.55a.974.974,0,0,1-.974.974H4.2a.974.974,0,0,1-.974-.974V5.323A.974.974,0,0,1,4.2,4.349h.974Z",
    transform: "translate(-2.25 -1.914)",
    fill: "#747474",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_166116",
    "data-name": "Path 166116",
    d: "M15.633.974H12.711a.487.487,0,0,0-.487.487v.974a.487.487,0,0,0,.487.487h2.922a.487.487,0,0,0,.487-.487V1.461A.487.487,0,0,0,15.633.974ZM12.711,0A1.461,1.461,0,0,0,11.25,1.461v.974A1.461,1.461,0,0,0,12.711,3.9h2.922a1.461,1.461,0,0,0,1.461-1.461V1.461A1.461,1.461,0,0,0,15.633,0Z",
    transform: "translate(-7.354)",
    fill: "#747474",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_166130",
    "data-name": "Path 166130",
    d: "M18.453,8.793a.615.615,0,0,1,0,.871l-3.691,3.691a.615.615,0,0,1-.871,0L12.045,11.51a.616.616,0,1,1,.871-.871l1.41,1.411,3.256-3.257a.615.615,0,0,1,.871,0Z",
    transform: "translate(-8.431 -2.552)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewedIcon);
export default __webpack_public_path__ + "static/media/reviewed-icon.153d3765b631d4136d6c41444a75999d.svg";
export { ForwardRef as ReactComponent };